import React, { useContext, useMemo } from 'react';
import TitleField from '../../TitleField/TitleField';
import AccordionTitleField from '../../TitleField/AccordionTitleField';
import RecordEditorUseAccordionContext from '../RecordEditorUseAccordionContext';
import ShowTitleContext from '../../TitleField/ShowTitleContext';
import isRootObject from '../../ObjectFieldTemplate/isRootObject';
var EmptyTitle = function EmptyTitle(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
export default function RecordEditorTitleField(props) {
  var useAccordionContext = useContext(RecordEditorUseAccordionContext);
  var formContext = props.formContext,
    idSchema = props.idSchema,
    title = props.title,
    isCollapsible = props.isCollapsible,
    isGroup = props.isGroup;
  var _isTopLevel = useMemo(function () {
    return isRootObject(idSchema, formContext, title);
  }, [idSchema, formContext, title]);
  var Component = useMemo(function () {
    var result = TitleField;
    if (title === '') {
      result = EmptyTitle;
    } else if (!_isTopLevel) {
      var hasId = idSchema !== undefined && idSchema.$id !== undefined && idSchema.id !== undefined;
      var isNumberedId = hasId && /_\d+$/.test(idSchema.$id);
      var _id = hasId ? idSchema.$id.substring(1).replace(/_\d+$/, '') : '';
      var _isArrayItemTitle = !isGroup && isNumberedId && formContext.schema !== undefined && (formContext.schema.properties !== undefined && formContext.schema.properties[_id] !== undefined && formContext.schema.properties[_id].type !== undefined && formContext.schema.properties[_id].type === 'array' || formContext.schema.type === 'array');
      var _isCollapsible = useAccordionContext !== null ? useAccordionContext : isCollapsible === undefined || isCollapsible === true;
      if (_isArrayItemTitle) {
        result = EmptyTitle;
      } else if (_isCollapsible && !formContext.isPrintView) {
        result = AccordionTitleField;
      }
    }
    return result;
  }, [_isTopLevel, isGroup, useAccordionContext, formContext, idSchema, isCollapsible]);
  return /*#__PURE__*/React.createElement(ShowTitleContext.Provider, {
    value: !_isTopLevel
  }, /*#__PURE__*/React.createElement(Component, props));
}